import { t } from 'i18next';
import { IdSchema, UuidSchema } from './common';
import * as v from 'valibot';

export const TagCategoryFormSchema = v.object({
	name: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
	tagRecords: v.record(
		UuidSchema,
		v.object({
			uuid: UuidSchema,
			id: v.nullable(IdSchema),
			name: v.pipe(
				v.string(),
				v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
			),
			color: v.nullable(v.string()),
			count: v.nullable(v.pipe(v.number(), v.integer())),
		}),
	),
});

export type TagCategoryFormModel = v.InferInput<typeof TagCategoryFormSchema>;
